import React from 'react'
import H1 from '../../components/H1'
import '../../styles/css/about.css'

const section = {
  target: 'about',
  title: 'About Us'
}

const About = () => (
  <div className="about">
    <div className="about-content">
      <div className="about-hero">
        <H1 section={section} />
        <p>NewGround Entertainment is a multi-faceted production company specializing in music, film and photography. We take pride and integrity in every project bearing NewGround's name. Every project no matter the scope or budget, is treated with the same level of passion and professionalism.</p>
      </div>
    </div>
  </div>
)

export default About


// WEBPACK FOOTER //
// ./src/containers/home/about.js